module.exports = __webpack_public_path__ + "static/media/Image5.c815f302.png";